export default __webpack_public_path__ + "static/WebSite_3DShowcaseMPuzhen_VideoQHD-8066cfbe26a87dffef7b88bda4b2f0d0.mp4";